export type SmokeToggleOptions = {
  button: HTMLButtonElement;
  initialEnabled?: boolean;
  onChange?: (enabled: boolean) => void;
};

export type SmokeToggleController = {
  isEnabled: () => boolean;
  setEnabled: (enabled: boolean) => void;
};

export function setupSmokeToggle({
  button,
  initialEnabled = true,
  onChange,
}: SmokeToggleOptions): SmokeToggleController {
  let enabled = initialEnabled;
  const stateEl = typeof (button as unknown as { querySelector?: unknown }).querySelector === 'function'
    ? (button.querySelector('.smoke-toggle-btn__state') as HTMLElement | null)
    : null;

  const render = () => {
    button.setAttribute('aria-pressed', enabled ? 'true' : 'false');
    button.setAttribute('aria-label', enabled ? 'Smoke on' : 'Smoke off');
    button.setAttribute('title', enabled ? 'Smoke on' : 'Smoke off');
    button.classList.toggle('smoke-toggle-btn--on', enabled);
    if (stateEl) stateEl.textContent = enabled ? 'ON' : 'OFF';
  };

  const setEnabled = (next: boolean) => {
    enabled = next;
    render();
    onChange?.(enabled);
  };

  const toggle = () => setEnabled(!enabled);

  button.type = 'button';
  button.addEventListener('click', (evt) => {
    evt.preventDefault();
    toggle();
  });

  button.addEventListener('keydown', (evt: KeyboardEvent) => {
    if (evt.key === ' ') {
      evt.preventDefault();
      toggle();
    }
  });

  render();

  return {
    isEnabled: () => enabled,
    setEnabled,
  };
}
